import { AfterViewInit, Directive, ElementRef, Input, Renderer2, HostListener } from '@angular/core';

@Directive({
  selector: '[ContentArea]'
})
export class ContentAreaDirective implements AfterViewInit {
  @Input() top:string;
  @Input() nav:string;
  constructor(private elRef: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit() {
    setTimeout(()=> this.checkAvailableHeight(),200);
  }

  @HostListener('window:resize')
  onResize() {
    setTimeout(()=> this.checkAvailableHeight(),200);
  }

  checkAvailableHeight(){
    let fotEl:number = 0;
    let body = this.elRef.nativeElement.getBoundingClientRect().top;
    let totalHeight = window.innerHeight;
    let footer = document.getElementById('jubloFooter')?.getBoundingClientRect();
    if(!!footer) fotEl = footer.height;
    let style = `calc(${totalHeight - 1}px - ${(+body.toFixed() + +fotEl.toFixed())}px)`;
    this.renderer.setStyle(this.elRef.nativeElement, 'height', style)
  }
}
